import Actor from "components/Activities/Actor";
import Subject from "components/Activities/Subject";
import { ErrorBoundary } from "components/Shared";
import { translate } from "lib";
import React from "react";

const DeclineSigner = ({ activity }: { activity: tcpinpoint.ActivityItem }) => (
	<ErrorBoundary>
		<Actor actor={activity.attributes.item.actor} /> {translate("declined to sign")}{" "}
		<Subject subject={activity.attributes.item.subject} />{" "}
	</ErrorBoundary>
);

export default DeclineSigner;
